<template>
  <div class="card inquiry-offers-cart pt-0 my-2">
    <div class="card-header pt-2 px-2 pb-2">
      <p class="heading-tiny text-light mr-2">{{ $t('inquiryOffersCart.selectedOffers') }} ({{ offersInCart.length }})
      </p>
    </div>
    <div class="card-body py-2 px-2">
      <template v-if="offersInCart.length">
        <transition name="slide">
          <ul class="list-plain">
            <li
              v-for="(offer, offerIndex) in offersInCart"
              :key="'offer-' + offerIndex"
              class="flex flex-align-items-center mb-1">
              <span class="offer-name text-medium-light">{{ offer.name }}<small v-if="offer.info">{{ offer.info }} </small></span>
              <f-button
                theme="close"
                class="ml-2"
                @click.prevent="removeOfferFromCart(offer.offer_id, offer.variant_id)">
              </f-button>
            </li>
          </ul>
        </transition>
      </template>
      <template v-else>
        {{ $t('inquiryOffersCart.offerNotYetAdded') }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inquiry-offers-cart',
  props: {
    allOffers: {
      default: () => [],
      type: Array
    },
    selectedProps: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    offersInCart () {
      let offersInCart = [];
      if (!this.allOffers || !this.allOffers.length) {
        return offersInCart;
      }
      let objKeys = Object.keys(this.selectedProps);

      for (let i = 0; i < objKeys.length; i++) {
        let currentItem = this.selectedProps[objKeys[i]];
        let currentOffer = this.allOffers.find(item => item.id === Number(objKeys[i]));
        if (currentItem && currentItem.selected && !currentItem.disabled) {
          offersInCart.push({
            info: '',
            name: currentOffer.name,
            offer_id: currentOffer.id,
            variant_id: null
          })
        }

        let objChildKeys = Object.keys(currentItem.variants);

        for (let j = 0; j < objChildKeys.length; j++) {
          let currentChildItem = currentItem.variants[objChildKeys[j]];
          if (currentChildItem && currentChildItem.selected && !currentChildItem.disabled) {
            let currentVariant = currentOffer.variants.find(child => child.id === Number(objChildKeys[j]))
            offersInCart.push({
              info: ` (${this.$t('inquiryOffersCart.offerVariant')} ${currentOffer.name})`,
              name: currentVariant.name,
              offer_id: currentOffer.id,
              variant_id: currentVariant.id
            });
          }
        }
      }

      return offersInCart;
    }
  },
  methods: {
    removeOfferFromCart (offerID, variantID = null) {
      this.$bus.$emit('offer-selected', false, offerID, variantID);
    }
  }
}
</script>
